import { CONTROL_BUCKET } from './default-buckets';

const VARIANT_A_BUCKET = 'variant_a';
const VARIANT_B_BUCKET = 'variant_b';
const VARIANT_C_BUCKET = 'variant_c';
const VARIANT_D_BUCKET = 'variant_d';
const BUCKETS = [
  CONTROL_BUCKET,
  VARIANT_A_BUCKET,
  VARIANT_B_BUCKET,
  VARIANT_C_BUCKET,
  VARIANT_D_BUCKET
];
const IDENTIFIER = 'BrowserCookieId';
const NAME = 'stc-dec-home-header-copy';

export {
  BUCKETS,
  CONTROL_BUCKET,
  VARIANT_A_BUCKET,
  VARIANT_B_BUCKET,
  VARIANT_C_BUCKET,
  VARIANT_D_BUCKET,
  IDENTIFIER,
  NAME
};
